import { isEmpty, isNil, keys } from 'lodash';
// Import Constants
import { DeliveryMethodTypes, l } from 'constants/common';
import { DeliveryMethodEnum } from 'enums';
import { DndSortedDataItem } from './types';

const getInitialDeliveryMethodConfig = ({
    option,
    availableDeliveryMethods,
    defaultValue,
}): DndSortedDataItem[] | [] => {
    // If there are no supported values OR no available delivery methods -> return empty array
    if (
        isEmpty(option?.CustomAttributes?.SupportedValues) ||
        isNil(availableDeliveryMethods) ||
        isEmpty(availableDeliveryMethods)
    ) {
        return [];
    }

    // Extract delivery method IDs from availableDeliveryMethods
    const receivedDeliveryMethodIds: number[] = availableDeliveryMethods.map((item) => item.DeliveryMethod);

    // Keep only supported IDs that actually exist in availableDeliveryMethods
    const filteredSupportedIds = option.CustomAttributes.SupportedValues.filter((value) =>
        receivedDeliveryMethodIds.includes(value),
    );

    const defaultValueIds: number[] = [];

    // Sort defaultValue keys by saved "orderId"
    const sortedIds = keys(defaultValue).sort((x, y) => defaultValue[x].orderId - defaultValue[y].orderId);

    // Add defaultValue IDs that are still supported
    sortedIds.forEach((deliveryMethodId) => {
        if (filteredSupportedIds.includes(+deliveryMethodId)) {
            defaultValueIds.push(Number(deliveryMethodId));
        }
    });

    // Append supported IDs that were NOT in defaultValue
    filteredSupportedIds.forEach((supportedId) => {
        if (!defaultValueIds.includes(supportedId)) {
            defaultValueIds.push(supportedId);
        }
    });

    const checkIsMultiProvider = (deliveryMethod) => {
        return (
            availableDeliveryMethods.find((item) => item.DeliveryMethod === deliveryMethod)?.IsMultiProvider || false
        );
    };

    // Build final array of config objects
    const result = defaultValueIds.map((deliveryMethod: DeliveryMethodEnum, index) => ({
        config: {
            deliveryMethodId: deliveryMethod,
            deliveryMethodName: l[DeliveryMethodTypes[deliveryMethod]],
            templateOption: {
                CustomAttributes: {
                    DeliveryMethod: deliveryMethod,
                    DisplayName: l.Template,
                },
            },

            ...(checkIsMultiProvider(deliveryMethod) && {
                providerOption: {
                    CustomAttributes: {
                        DeliveryMethod: deliveryMethod,
                        DisplayName: l.Provider,
                    },
                },
            }),
        },

        id: l[DeliveryMethodTypes[deliveryMethod]],
        name: l[DeliveryMethodTypes[deliveryMethod]],
        index,
    }));

    return result;
};

export { getInitialDeliveryMethodConfig };
